import React, { useState, useEffect } from 'react'
import { getAllIndAsExceptionTags, updateIndAsExceptionTagStatus } from '../../../services/asset.service';
import Box from '@mui/material/Box';
import { DataGrid, GridToolbarContainer, GridToolbarExport, GridOverlay } from '@mui/x-data-grid';
import * as CryptoJS from "crypto-js";
import CircularProgress from '@mui/material/CircularProgress';
import '../AssetInfo/AssetList.css';
import '../AssetInfo/DataGridStyles.css';

/* ─── Date Helper (unchanged) ─── */
function getFormatedDate(dateString) {
    if (dateString != null) {
        let dte = new Date(dateString);
        let year = dte.getFullYear();
        let month = dte.getMonth() + 1;
        let day = dte.getDate();
        if (month < 10) month = '0' + month;
        if (day < 10) day = '0' + day;
        return year + '-' + month + '-' + day;
    } else {
        return null;
    }
}

const CustomLoader = () => (
    <GridOverlay>
        <CircularProgress color="primary" size={30} />
    </GridOverlay>
);

function CustomToolbar() {
    return (
        <GridToolbarContainer>
            <GridToolbarExport
                csvOptions={{
                    fileName: 'exception_tags_list',
                }}
            />
        </GridToolbarContainer>
    );
}

/* ─── Status Change Handlers (unchanged logic) ─── */
const handleStatusChange = (id, currentStatus) => {
    const newStatus = (currentStatus === '1') ? '0' : '1';
    if (window.confirm(`Are you sure you want to change status to ${newStatus === '1' ? 'Active' : 'Inactive'}?`)) {
        try {
            let EncryptData = CryptoJS.AES.encrypt(JSON.stringify({
                'param_data': { 'id': id, 'status': newStatus },
                'authToken': sessionStorage.getItem('LoggedInToken'),
            }), process.env.REACT_APP_ENCRYPT_SECRET_KEY).toString();
            let oData = { 'token': EncryptData };
            updateIndAsExceptionTagStatus(oData).then((result) => {
                const response = result.data;
                if (response.data.affectedRows == 1) {
                    alert('Status updated successfully!');
                    window.location.reload();
                } else {
                    alert('Failed to update status: ' + (response.data.message || 'Unknown error'));
                }
            })
        } catch (error) {
            console.error('Error updating status:', error);
            alert('An error occurred while updating status');
        }
    }
};

const handleFinalStatusChange = (id, finaltStatus) => {
    const newStatus = (finaltStatus === 'Finalized') ? 'Pending' : 'Finalized';
    if (window.confirm(`Are you sure you want to change status to ${finaltStatus === 'Finalized' ? 'Finalized' : 'Pending'}?`)) {
        try {
            let EncryptData = CryptoJS.AES.encrypt(JSON.stringify({
                'param_data': { 'id': id, 'final_status': newStatus },
                'authToken': sessionStorage.getItem('LoggedInToken'),
            }), process.env.REACT_APP_ENCRYPT_SECRET_KEY).toString();
            let oData = { 'token': EncryptData };
            updateIndAsExceptionTagStatus(oData).then((result) => {
                const response = result.data;
                if (response.data.affectedRows == 1) {
                    alert('Status updated successfully!');
                    window.location.reload();
                } else {
                    alert('Failed to update status: ' + (response.data.message || 'Unknown error'));
                }
            })
        } catch (error) {
            console.error('Error updating status:', error);
            alert('An error occurred while updating status');
        }
    }
};

function IndAsExceptionTags() {
    /* ─── All State (unchanged) ─── */
    const [loading, setLoading] = useState(true);
    const [assetsDepriciation, setAssetsDepriciation] = useState([]);

    /* ─── Columns (backend unchanged – enhanced styling) ─── */
    const columns = [
        { field: "id", hide: true, headerName: "Sl No" },
        { field: "cin_no", hide: false, headerName: "CIN No.", width: 250 },
        {
            field: "tag", hide: false, headerName: "Tag", width: 250,
            renderCell: (params) => (
                <div className="tag-cell">
                    <i className="bi bi-tag-fill"></i>
                    {params.value}
                </div>
            )
        },
        { field: "from_module", hide: false, headerName: "From Module", width: 250 },
        { field: "depreciation_status", hide: false, headerName: "Depreciation Status", width: 150 },
        {
            field: "depreciation_final_status",
            headerName: "Depreciation Final Status",
            width: 210,
            renderCell: ({ row }) => {
                const isFinalized = row.depreciation_final_status === "Finalized";
                const isInactiveException = row.status === "0";
                const nonEditable = isFinalized || isInactiveException;

                return (
                    <div
                        className={`al-status-badge ${isFinalized ? 'al-status-success' : 'al-status-warning'} ${nonEditable ? 'al-status-disabled' : 'al-status-clickable'}`}
                        onClick={
                            nonEditable
                                ? undefined
                                : (e) => {
                                    e.stopPropagation();
                                    handleFinalStatusChange(row.id, row.depreciation_final_status);
                                }
                        }
                    >
                        <i className={`bi ${isFinalized ? 'bi-check-circle-fill' : 'bi-clock-fill'}`} />
                        {isFinalized ? "Finalized" : "Pending"}
                    </div>
                );
            },
        },
        {
            field: "status",
            headerName: "Status",
            width: 150,
            valueFormatter: (params) => (params.value === '1' || params.value === 1 ? 'Active' : 'Inactive'),
            valueGetter: (params) => (params.row.status === '1' || params.row.status === 1 ? 'Active' : 'Inactive'),
            renderCell: ({ row }) => {
                const isFinalized = row.depreciation_final_status === "Finalized";
                const isActive = row.status === "1" || row.status === 1;
                const nonEditable = isFinalized;

                return (
                    <div
                        className={`al-status-badge ${isActive ? 'al-status-success' : 'al-status-danger'} ${nonEditable ? 'al-status-disabled' : 'al-status-clickable'}`}
                        onClick={
                            nonEditable
                                ? undefined
                                : (e) => {
                                    e.stopPropagation();
                                    handleStatusChange(row.id, row.status);
                                }
                        }
                    >
                        <i className={`bi ${isActive ? 'bi-check-circle-fill' : 'bi-x-circle-fill'}`} />
                        {isActive ? "Active" : "Inactive"}
                    </div>
                );
            },
        },
        {
            field: "record_month",
            headerName: "Record Month",
            width: 130,
            hide: false,
            valueFormatter: (params) => {
                if (params.value == null) return "";
                const m = Number(params.value) - 1;
                return new Date(2000, m, 1).toLocaleString("default", { month: "long" });
            },
            comparator: (valueA, valueB) => Number(valueA) - Number(valueB),
        },
        { field: "created_by_name", hide: false, headerName: "Created By", width: 130 },
        {
            field: "created_at", hide: false, headerName: "Created Date", width: 130,
            valueFormatter: (params) => getFormatedDate(params.value),
            renderCell: (params) => <p>{getFormatedDate(params.row.created_at)}</p>
        },
    ];

    /* ─── Data Fetching (unchanged logic) ─── */
    useEffect(() => {
        let EncryptData = CryptoJS.AES.encrypt(JSON.stringify({
            'authToken': sessionStorage.getItem('LoggedInToken'),
        }), process.env.REACT_APP_ENCRYPT_SECRET_KEY).toString();

        let oData = { 'token': EncryptData };

        getAllIndAsExceptionTags(oData).then((result) => {
            const data = result.data.data;
            if (data?.exceptionTags && data.exceptionTags.length > 0) {
                setAssetsDepriciation(data.exceptionTags);
            }
        }).finally(() => {
            setLoading(false);
        });
    }, []);

    /* ─── RENDER ─── */
    return (
        <div className="al-page" id="exception-tags-page">

            {/* ══ PAGE HEADER ══ */}
            <div className="al-page-header" id="al-page-header">
                <div className="al-page-header-left">
                    <div className="al-page-header-icon">
                        <i className="bi bi-exclamation-triangle-fill" />
                    </div>
                    <div className="al-page-header-text">
                        <h5 className="al-page-title">Exception Tags(Ind AS) List</h5>
                        <p className="al-page-subtitle">Manage depreciation exceptions and status updates</p>
                    </div>
                </div>
                {!loading && assetsDepriciation.length > 0 && (
                    <div className="al-record-badge" id="al-record-badge">
                        <i className="bi bi-exclamation-diamond-fill" />
                        <strong>{assetsDepriciation.length.toLocaleString('en-IN')}</strong>&nbsp;Exception Records
                    </div>
                )}
            </div>

            {/* ══ DATA GRID CARD ══ */}
            <div className="al-grid-card" id="al-grid-card">
                <div className="al-grid-card-header">
                    <span className="al-grid-card-title">
                        <i className="bi bi-table" /> Exception Tag(Ind AS) Records
                    </span>
                    {!loading && assetsDepriciation.length > 0 && (
                        <span className="al-showing-badge">
                            Showing <strong>{assetsDepriciation.length}</strong> records
                        </span>
                    )}
                </div>

                <Box>
                    <DataGrid
                        rows={assetsDepriciation}
                        getRowId={(row) => row.id}
                        columns={columns}
                        autoHeight
                        className="al-data-grid"
                        components={{
                            Toolbar: CustomToolbar,
                            LoadingOverlay: CustomLoader,
                        }}
                        loading={loading}
                    />
                </Box>
            </div>
        </div>
    )
}

export default IndAsExceptionTags